import { NavigationMapItem, NavigationMapItemPermissionsType } from '@lumapps/navigation/types';

export const nodeIsHidden = (nodePermission?: NavigationMapItemPermissionsType) => nodePermission === 'none';

/**
 *  Display Edit Action if:
 *  - no permission, OR
 *  - permission is set to 'edit' or 'all'
 */
export const nodeIsEditable = (nodePermission?: NavigationMapItemPermissionsType) =>
    nodePermission === undefined || [undefined, 'edit', 'all'].includes(nodePermission);

/**
 *  Display Delete Action if:
 *  - no nodePermission, OR
 *  - permission is set to 'all'
 */
export const nodeIsDeletable = (nodePermission?: NavigationMapItemPermissionsType) =>
    [undefined, 'all'].includes(nodePermission);
/**
 *  Display Move Action if:
 *  - no nodePermission, OR
 *  - permission is set to 'all'
 */
export const nodeIsMovable = (nodePermission?: NavigationMapItemPermissionsType) =>
    [undefined, 'all'].includes(nodePermission);

/**
 * Get the navigation map item title object to use.
 * If the nodeTitle has a value in the given language, use it.
 * If not, use title
 */
export const getNavigationMapNodeTitle = (node: Pick<NavigationMapItem, 'title' | 'nodeTitle'>, language?: string) => {
    /* If language is set, do the test relative to the given language. We only return node title if the node title has a
     * language defined in this language
     */
    if (language && node.nodeTitle?.translations[language]) {
        return node.nodeTitle;
    }

    /** If language is not set, check the the nodeTitle value to assert whether we should return the nodeTitle or title. */
    return node.nodeTitle?.value ? node.nodeTitle : node.title;
};
